export default __webpack_public_path__ + "static/media/seller1.0c86b331.jpg";